
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30968',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30968",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55545",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8478",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11934",
  "I18n": "static-7.1700",
  "quartz": "static-1.7619",
  "quartz-config": "static-1.1397",
  "quartz-core": "static-1.6838",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1062",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55532",
  "feedback-utils": "static-1.55536",
  "forms-embed-utils-lib": "static-1.4904",
  "forms-utils-lib": "static-1.13283",
  "foundations-assets": "static-1.5327",
  "foundations-components": "static-1.8693",
  "foundations-theming": "static-1.4927",
  "hub-http": "static-1.6650",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12241",
  "icons": "static-2.700",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4209",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1-use-beacon-keepalive-queue.3",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5640",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.514",
  "tinymce-plugins": "static-1.58454",
  "transmute": "static-2.97",
  "ui-images": "static-2.1270",
  "UIComponents": "static-3.8880",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3896",
  "quartz-webpack": "static-1.3843",
  "foundations-theming-specialty": "static-1.2643",
  "property-description-translator": "static-1.4260",
  "HeadJS": "static-2.817",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3589",
  "msw": "static-1.102",
  "msw-config": "static-1.25",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4749",
  "jasmine-runner": "static-1.6891",
  "opentelemetry-fe-types": "static-1.230",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.903",
  "hubspotter-http": "static-1.4953",
  "mobile-manifest-mixins": "static-1.601",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.605",
  "quartz-auth": "static-1.1294",
  "quartz-head": "static-1.1284",
  "quartz-i18n": "static-1.1294",
  "quartz-routing": "static-1.1049",
  "quartz-test": "static-1.1294",
  "quartz-tracking": "static-1.998",
  "trellis-components": "static-1-rdeane_hubspot-tooltip-trigger-canary.40",
  "ui-fonts": "static-1.1196",
  "usage-tracker-container": "static-1.7753",
  "usage-tracker-core": "static-1.7613",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.330",
  "conversations-skeleton-state": "static-1.7603",
  "reference-resolvers": "static-1.8621",
  "sanitize-text": "static-1.8597",
  "PatternValidationJS": "static-1.3327",
  "ReduxMessenger": "static-2.10811",
  "outpost": "static-1.4574",
  "rpc-client-utils": "static-1.5113",
  "sanitize": "static-1.4915",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4962",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9866",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.97",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1-rdeane_hubspot-tooltip-trigger-canary.40",
  "bend-plugin-foundations-theming": "static-1.3410",
  "foundations-theming-base": "static-1.3912",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.379",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.141",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.9960",
  "atom": "static-1.5518",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8373",
  "ContentUtils": "static-1.69404",
  "data-token-picker": "static-1.17078",
  "file-manager-components": "static-1.24781",
  "FileManagerCore": "static-1.40280",
  "FileManagerLib": "static-1.40421",
  "frontend-preferences-client": "static-1.8359",
  "hub-http-contrib": "static-1.3470",
  "interframe": "static-3.5182",
  "layout-dnd-components": "static-1.13167",
  "layout-dnd-utils": "static-1.12142",
  "property-translator": "static-1.5820",
  "react-codemirror": "static-1.11081",
  "react-colorpicker": "static-2.10652",
  "reference-resolvers-lite": "static-1.8549",
  "rich-text-lib": "static-1.20501",
  "tinymce-data": "static-1.41425",
  "tinymce-themes": "static-1.57310",
  "ui-addon-emoji-picker": "static-1.10306",
  "ui-addon-sales-email": "static-1.5643",
  "ui-brand-identity-lib": "static-1.16875",
  "bender-build-tools": "static-1.3518",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1431",
  "tanstack-virtual": "static-1.42",
  "stylex-utils": "static-1.169",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10847",
  "hubspotter-http-shared-msw-handlers": "static-1.10845",
  "usage-tracker-session-replay": "static-1.5449",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.523",
  "chirp-fetch": "static-1.2343",
  "chatspot-core": "static-1.23632",
  "copilot-toolkit": "static-1.12088",
  "customer-data-objects-ui-components": "static-1.13471",
  "data-fetching-client": "static-1.10081",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5199",
  "ui-addon-video-player": "static-1.9065",
  "ui-coaching-tips": "static-1.29543",
  "usage-tracker": "static-1.7763",
  "cms-field-types": "static-1.5254",
  "content-icons-ui": "static-1.2425",
  "integrations-lib": "static-1.17335",
  "customer-data-objects": "static-1.8135",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2056",
  "apollo-link-hub-http": "static-2.5028",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4582",
  "poll-commands": "static-1.3916",
  "ui-addon-iframeable": "static-1.9517",
  "video-components-external": "static-1.12374",
  "video-data-lib": "static-1.36032",
  "audio-components": "static-1.6521",
  "breeze-artifacts-sdk": "static-1.784",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30008",
  "FileManagerImages": "static-1.37932",
  "foundations-components-legacy": "static-1.1718",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.697",
  "ui-universal-auth": "static-1.9663",
  "urlinator": "static-1.4956",
  "video-components": "static-1.14376",
  "video-embed": "static-1.36866",
  "ts-schema": "static-1.4379",
  "ContentData": "static-1.69479",
  "layout-data-lib": "static-1.10467",
  "react-dnd-compat": "static-1.5051",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1988",
  "external-options-client-types": "static-1.4427",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6033",
  "hs-resources": "static-1.634",
  "inbound-db-properties-service-client": "static-1.4129",
  "NamespacedHubStyle": "static-2.9346",
  "growth-onboarding-confetti": "static-1.3502",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11586",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5879",
  "magpie-types": "static-1.5339",
  "simple-logging-lib": "static-1.3493",
  "avatar-components": "static-1.2925",
  "customer-data-ui-utilities": "static-1.10274",
  "growth-onboarding-feedback-components": "static-1.7023",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5320",
  "integrations-error-boundary-lib": "static-1.14750",
  "integrations-tracking-lib": "static-1.6056",
  "laboratory-lib": "static-3.7591",
  "native-integrations-shared-strings": "static-1.8204",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10717",
  "unified-auth": "static-1.1177",
  "breeze-engine-chat-components": "static-1.1034",
  "breeze-engine-core": "static-1.1334",
  "ably": "static-2.2",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1083",
  "navigation-messaging": "static-1.8427",
  "content-media-composition-data-lib": "static-1.13531",
  "content-media-compositions": "static-2.17538",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19591",
  "nudge-client-utils": "static-1.3361",
  "unified-auth-core-lib": "static-1.1459",
  "social-insights-client-types": "static-1.22877",
  "advanced-menus-core": "static-1.15761",
  "advanced-menus-lib": "static-1.12524",
  "ExportDialog": "static-6.10812",
  "ui-memberships-settings-lib": "static-1.35119",
  "conditional-properties-service-client": "static-1.4098",
  "crm-pipelines-api-client-types": "static-1.4429",
  "event-emitter": "static-1.1401",
  "fdsr-migration-layer": "static-1.454",
  "framework-builder-read-service-client": "static-1.4311",
  "inbound-db-meta-service-client": "static-1.3756",
  "multi-currency-client-types": "static-1.3994",
  "foundations-components-test-utils": "static-1.6176",
  "reactive-lib": "static-1.1164",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.779",
  "universal-page-editor-lib": "static-1.3450",
  "adobe-sign-auth-lib": "static-1.708",
  "ads-unified-auth-lib": "static-1.1837",
  "custom-vendor-connection-lib": "static-1.227",
  "google-sheets-integration-lib": "static-1.1274",
  "microsoft-drive-auth-lib": "static-1.434",
  "slack-ui-library": "static-1.10839",
  "surveymonkey-integration-lib": "static-1.804",
  "bend-plugin-pulse": "static-1.586",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30737",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3118",
  "nudge-renderer-utils": "static-1.3437",
  "onboarding-tours": "static-1.17347",
  "whisper-core-api": "static-1.7583",
  "fsm": "static-1.4199",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15760",
  "simple-menus-lib": "static-1.17277",
  "settings-ui-lib": "static-1.12970",
  "persist-promise": "static-1.4145",
  "crm-record-cards-service-types": "static-1.3851",
  "framework-data-schema-resolvers": "static-1.7335",
  "location-customization-utils-lib": "static-1.10361",
  "getting-started-shared-tasks": "static-1.19505",
  "growth-data-modal": "static-1.6084",
  "growth-onboarding-next-action-utils": "static-1.2928",
  "navigation-components": "static-1.19100",
  "onboarding-tours-client": "static-1.5562",
  "onboarding-tours-utils": "static-1.1414",
  "ui-shepherd-tracker": "static-1.8098",
  "user-context": "static-1.5494",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7240",
  "onboarding-data-sync-lib": "static-1.2788",
  "growth-onboarding-next-action-components": "static-1.2956",
  "user-context-client": "static-1.4950",
  "nest": "static-1.675",
  "getting-started-shared-tasks-store": "static-1.18623",
  "InboxConnectUtils": "static-4.15789",
  "meetings-connect-utils-lib": "static-1.8057",
  "onboarding-scopes": "static-1.6893"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30968",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55545",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8478",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11934",
  "I18n": "/I18n/static-7.1700",
  "quartz": "/quartz/static-1.7619",
  "quartz-config": "/quartz-config/static-1.1397",
  "quartz-core": "/quartz-core/static-1.6838",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1062",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55532",
  "feedback-utils": "/feedback-utils/static-1.55536",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4904",
  "forms-utils-lib": "/forms-utils-lib/static-1.13283",
  "foundations-assets": "/foundations-assets/static-1.5327",
  "foundations-components": "/foundations-components/static-1.8693",
  "foundations-theming": "/foundations-theming/static-1.4927",
  "hub-http": "/hub-http/static-1.6650",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12241",
  "icons": "/icons/static-2.700",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4209",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1-use-beacon-keepalive-queue.3",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5640",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "tinymce-plugins": "/tinymce-plugins/static-1.58454",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1270",
  "UIComponents": "/UIComponents/static-3.8880",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3896",
  "quartz-webpack": "/quartz-webpack/static-1.3843",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2643",
  "property-description-translator": "/property-description-translator/static-1.4260",
  "HeadJS": "/HeadJS/static-2.817",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3589",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.25",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4749",
  "jasmine-runner": "/jasmine-runner/static-1.6891",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.230",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.903",
  "hubspotter-http": "/hubspotter-http/static-1.4953",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.601",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.605",
  "quartz-auth": "/quartz-auth/static-1.1294",
  "quartz-head": "/quartz-head/static-1.1284",
  "quartz-i18n": "/quartz-i18n/static-1.1294",
  "quartz-routing": "/quartz-routing/static-1.1049",
  "quartz-test": "/quartz-test/static-1.1294",
  "quartz-tracking": "/quartz-tracking/static-1.998",
  "trellis-components": "/trellis-components/static-1-rdeane_hubspot-tooltip-trigger-canary.40",
  "ui-fonts": "/ui-fonts/static-1.1196",
  "usage-tracker-container": "/usage-tracker-container/static-1.7753",
  "usage-tracker-core": "/usage-tracker-core/static-1.7613",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.330",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "reference-resolvers": "/reference-resolvers/static-1.8621",
  "sanitize-text": "/sanitize-text/static-1.8597",
  "PatternValidationJS": "/PatternValidationJS/static-1.3327",
  "ReduxMessenger": "/ReduxMessenger/static-2.10811",
  "outpost": "/outpost/static-1.4574",
  "rpc-client-utils": "/rpc-client-utils/static-1.5113",
  "sanitize": "/sanitize/static-1.4915",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4962",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9866",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.97",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1-rdeane_hubspot-tooltip-trigger-canary.40",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3410",
  "foundations-theming-base": "/foundations-theming-base/static-1.3912",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.379",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.141",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9960",
  "atom": "/atom/static-1.5518",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8373",
  "ContentUtils": "/ContentUtils/static-1.69404",
  "data-token-picker": "/data-token-picker/static-1.17078",
  "file-manager-components": "/file-manager-components/static-1.24781",
  "FileManagerCore": "/FileManagerCore/static-1.40280",
  "FileManagerLib": "/FileManagerLib/static-1.40421",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8359",
  "hub-http-contrib": "/hub-http-contrib/static-1.3470",
  "interframe": "/interframe/static-3.5182",
  "layout-dnd-components": "/layout-dnd-components/static-1.13167",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12142",
  "property-translator": "/property-translator/static-1.5820",
  "react-codemirror": "/react-codemirror/static-1.11081",
  "react-colorpicker": "/react-colorpicker/static-2.10652",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8549",
  "rich-text-lib": "/rich-text-lib/static-1.20501",
  "tinymce-data": "/tinymce-data/static-1.41425",
  "tinymce-themes": "/tinymce-themes/static-1.57310",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10306",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5643",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16875",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1431",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "stylex-utils": "/stylex-utils/static-1.169",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10847",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10845",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5449",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.523",
  "chirp-fetch": "/chirp-fetch/static-1.2343",
  "chatspot-core": "/chatspot-core/static-1.23632",
  "copilot-toolkit": "/copilot-toolkit/static-1.12088",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13471",
  "data-fetching-client": "/data-fetching-client/static-1.10081",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5199",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9065",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29543",
  "usage-tracker": "/usage-tracker/static-1.7763",
  "cms-field-types": "/cms-field-types/static-1.5254",
  "content-icons-ui": "/content-icons-ui/static-1.2425",
  "integrations-lib": "/integrations-lib/static-1.17335",
  "customer-data-objects": "/customer-data-objects/static-1.8135",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2056",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5028",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4582",
  "poll-commands": "/poll-commands/static-1.3916",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9517",
  "video-components-external": "/video-components-external/static-1.12374",
  "video-data-lib": "/video-data-lib/static-1.36032",
  "audio-components": "/audio-components/static-1.6521",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.784",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30008",
  "FileManagerImages": "/FileManagerImages/static-1.37932",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1718",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.697",
  "ui-universal-auth": "/ui-universal-auth/static-1.9663",
  "urlinator": "/urlinator/static-1.4956",
  "video-components": "/video-components/static-1.14376",
  "video-embed": "/video-embed/static-1.36866",
  "ts-schema": "/ts-schema/static-1.4379",
  "ContentData": "/ContentData/static-1.69479",
  "layout-data-lib": "/layout-data-lib/static-1.10467",
  "react-dnd-compat": "/react-dnd-compat/static-1.5051",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1988",
  "external-options-client-types": "/external-options-client-types/static-1.4427",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6033",
  "hs-resources": "/hs-resources/static-1.634",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4129",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9346",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3502",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11586",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5879",
  "magpie-types": "/magpie-types/static-1.5339",
  "simple-logging-lib": "/simple-logging-lib/static-1.3493",
  "avatar-components": "/avatar-components/static-1.2925",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10274",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7023",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5320",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14750",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6056",
  "laboratory-lib": "/laboratory-lib/static-3.7591",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8204",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10717",
  "unified-auth": "/unified-auth/static-1.1177",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1034",
  "breeze-engine-core": "/breeze-engine-core/static-1.1334",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1083",
  "navigation-messaging": "/navigation-messaging/static-1.8427",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13531",
  "content-media-compositions": "/content-media-compositions/static-2.17538",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19591",
  "nudge-client-utils": "/nudge-client-utils/static-1.3361",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1459",
  "social-insights-client-types": "/social-insights-client-types/static-1.22877",
  "advanced-menus-core": "/advanced-menus-core/static-1.15761",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12524",
  "ExportDialog": "/ExportDialog/static-6.10812",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35119",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4098",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4429",
  "event-emitter": "/event-emitter/static-1.1401",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.454",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4311",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3756",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3994",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6176",
  "reactive-lib": "/reactive-lib/static-1.1164",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.779",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3450",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.708",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1837",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.227",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1274",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.434",
  "slack-ui-library": "/slack-ui-library/static-1.10839",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.804",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.586",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30737",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3118",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3437",
  "onboarding-tours": "/onboarding-tours/static-1.17347",
  "whisper-core-api": "/whisper-core-api/static-1.7583",
  "fsm": "/fsm/static-1.4199",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15760",
  "simple-menus-lib": "/simple-menus-lib/static-1.17277",
  "settings-ui-lib": "/settings-ui-lib/static-1.12970",
  "persist-promise": "/persist-promise/static-1.4145",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3851",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7335",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10361",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19505",
  "growth-data-modal": "/growth-data-modal/static-1.6084",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2928",
  "navigation-components": "/navigation-components/static-1.19100",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5562",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1414",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8098",
  "user-context": "/user-context/static-1.5494",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7240",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2788",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2956",
  "user-context-client": "/user-context-client/static-1.4950",
  "nest": "/nest/static-1.675",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18623",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15789",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8057",
  "onboarding-scopes": "/onboarding-scopes/static-1.6893"
}
};
